import { SelectOption } from '@models/select-option';

export const JobExperienceOptions: SelectOption[] = [
  { label: 'Sin experiencia', value: 0 },
  { label: '1 año', value: 1 },
  { label: '2 años', value: 2 },
  { label: '3 años', value: 3 },
  { label: '4 años', value: 4 },
  { label: '5 años', value: 5 },
  { label: 'Más de 5 años', value: 6 },
];
